module.exports = __webpack_public_path__ + "img/emoji_28.33cb7909.png";